import { FC } from 'react';
import styled from 'styled-components';

import Button, { ButtonProps } from 'components/_core/Button';
import Text from 'components/_core/Text';

export const Section = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.abs24}px;

  :last-child {
    margin-bottom: 0;
  }
`;

export const SectionLabel = styled(Text).attrs({
  fontWeight: 'weight-500',
  variant: 'primary',
})`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
`;

export const SectionButtons = styled.div``;

export const RadioButton: FC<ButtonProps> = (props) => (
  <Button
    _last={{ marginRight: 'space-0' }}
    display="inline-block"
    marginRight="space-24"
    {...props}
  />
);

export const ErrorText = styled(Text).attrs({
  color: 'red.0',
  size: 'sm',
})`
  display: block;
  margin-top: ${({ theme }) => theme.spacings.abs8}px;
`;
